import { Box, Typography, Stack, Button, LinearProgress } from '@packages/shared';
import { LoadReload32 } from '@packages/themes/icons';
import { useIntl } from 'react-intl';

type LoadMoreProps = {
  /** Shown ratings */
  shown: number;
  /** Number of all ratings */
  reviewCount: number;
  /** Load more button click handler  */
  onLoadMore: () => void;
};

/**
 * Indicator and button to show more ratings
 */
export const LoadMore = ({ shown, reviewCount, onLoadMore }: LoadMoreProps) => {
  const { formatMessage } = useIntl();

  return (
    <Stack spacing={2} sx={{ width: '100%', maxWidth: 300 }}>
      <Box>
        <Typography variant="body2" sx={{ mb: 1, textAlign: 'center' }}>
          {formatMessage(
            {
              id: 'customer-ratings.paging.count.label',
              defaultMessage: 'Du hast {shown} von {reviewCount} Bewertungen gesehen',
            },
            { shown, reviewCount },
          )}
        </Typography>
        <LinearProgress variant="determinate" value={(shown * 100) / reviewCount} color="info" />
      </Box>
      <Button
        fullWidth
        endIcon={<LoadReload32 />}
        onClick={onLoadMore}
        disabled={shown === reviewCount}
      >
        {formatMessage({
          id: 'customer-ratings.paging.load-more',
          defaultMessage: 'Mehr Bewertungen anzeigen',
        })}
      </Button>
    </Stack>
  );
};
